import { posthog } from 'posthog-js';
import { useCallback, useEffect, useState } from 'react';

export const usePosthogDistinctId = () => {
  const [distinctId, setDistinctId] = useState<string | null>(null);

  useEffect(() => {
    // Get the current distinct ID
    const currentDistinctId = posthog.get_distinct_id();
    setDistinctId(currentDistinctId);
  }, []);

  const generateNewDistinctId = useCallback(() => {
    // Generate a new UUID for distinct ID
    const newDistinctId = crypto.randomUUID();
    posthog.identify(newDistinctId);
    setDistinctId(newDistinctId);
    return newDistinctId;
  }, []);

  const resetDistinctId = useCallback(() => {
    // Reset to anonymous ID
    posthog.reset();

    const anonymousId = posthog.get_distinct_id();
    setDistinctId(anonymousId);
    return anonymousId;
  }, []);

  const aliasUser = useCallback((userId: string) => {
    // Create an alias between the anonymous ID and the user ID
    const currentDistinctId = posthog.get_distinct_id();

    if (currentDistinctId !== userId) {
      posthog.alias(userId);
    }
  }, []);

  return {
    distinctId,
    generateNewDistinctId,
    resetDistinctId,
    aliasUser,
  };
};

export default usePosthogDistinctId;
